import { render, staticRenderFns } from "./BaseExpiringContracts.vue?vue&type=template&id=41145970&scoped=true"
import script from "./BaseExpiringContracts.vue?vue&type=script&lang=js"
export * from "./BaseExpiringContracts.vue?vue&type=script&lang=js"
import style0 from "./BaseExpiringContracts.vue?vue&type=style&index=0&id=41145970&prod&scoped=true&lang=css"
import style1 from "./BaseExpiringContracts.vue?vue&type=style&index=1&id=41145970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41145970",
  null
  
)

export default component.exports